import React from "react";
import loader from "../../Assets/images/loader.gif";

const Loading = ({ width = "3%" }) => {
  return <img alt="Loader" style={{ width: width }} src={loader} />;
};

export default Loading;
